export default "__VITE_ASSET__CrV28zSe__"